import { actionAddException } from 'react-redux-app/lib/modules/exception/actions';

import {
  ACTION_LOAD_SITE_FOOTER_LINKS__FAIL,
  ACTION_LOAD_SITE_FOOTER_LINKS__REQUEST,
  ACTION_LOAD_SITE_FOOTER_LINKS__SUCCESS,
} from '../actionTypes';

import { actionAddLinkData, actionAddCategoriesData } from './index';

import { getCurrentSiteId } from '../../site/selectors';


const actionLoadSiteFooterLinksSuccess = () => ({
  type: ACTION_LOAD_SITE_FOOTER_LINKS__SUCCESS,
});

const actionLoadSiteFooterLinksFail = error => ({
  type: ACTION_LOAD_SITE_FOOTER_LINKS__FAIL,
  payload: { error },
});

export const actionLoadSiteFooterLinksRequest = () => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_LOAD_SITE_FOOTER_LINKS__REQUEST,
    });

    return apiClientHelper.get(
      `/rest/webmaster/site_link/${getCurrentSiteId(getState())}`
    ).then(
      ({
        links, siteLinkMaxNumberReached, categories, siteLinkCategoriesMaxNumberReached,
      }) => {
        actionAddCategoriesData(dispatch, categories, siteLinkCategoriesMaxNumberReached);
        actionAddLinkData(dispatch, links, siteLinkMaxNumberReached);
        dispatch(actionLoadSiteFooterLinksSuccess());
      },
      error => {
        dispatch(actionLoadSiteFooterLinksFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);
